"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectDestructuringEmpty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectDestructuringEmpty"));

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function SuccessDialog(_ref) {
  (0, _objectDestructuringEmpty2["default"])(_ref);

  try {
    var iconClassName = (0, _classnames["default"])(_defaultModule["default"]['icon'], 'icon-success');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['success']
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['thumb']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: iconClassName
    })), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['header']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Header, {
      level: 4
    }, "\u041E\u0431\u043C\u0435\u043D \u0432\u0430\u043B\u044E\u0442", /*#__PURE__*/_react["default"].createElement("br", null), "\u043F\u0440\u043E\u0448\u0435\u043B \u0443\u0441\u043F\u0435\u0448\u043D\u043E")), /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['content']
    }, /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'body'
    }, "\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u044F \u043E\u0431\u043C\u0435\u043D\u0430 \u043E\u0442\u043E\u0431\u0440\u0430\u0437\u0438\u0442\u0441\u044F", /*#__PURE__*/_react["default"].createElement("br", null), "\u0432 \u0432\u044B\u043F\u0438\u0441\u043A\u0435")));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = SuccessDialog;
exports["default"] = _default;